export default "__VITE_ASSET__CnND0iOq__"